// import React, { Component } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// // reactstrap components
// import {
//   Card,
//   Card.Body,
//   Card.Header,
//   CardTitle,
//   Table,
//   Row,
//   Col,
//   Button,
//   TabContent,
//   TabPane,
//   Nav,
//   NavItem,
//   CardText,
//   NavLink as NavLink1,
// } from "reactstrap";
// import API from "api.js";
// import ChromeCheck from "views/ChromeCheckGlobal.jsx";
// import { NavLink } from "react-router-dom";
// import { setUser } from "action/index.js";
// // core components
// import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
// import { connect } from "react-redux";
// import { thead, tbody } from "variables/general";
// import { store, persistor } from "store/index";
// import { Helmet } from "react-helmet";
// import TopNavPills from "components/SectionalTest/TopNavPills";
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
// import ArrowIcon from "../assets/images/images_new/sidebar-icons/06.svg";
// import ExtensiveMockTour from "components/WebsiteTour/ExtensiveMockTour";
// import MockTour from "components/WebsiteTour/MockTour";

// const mapStateToProps = (state) => {
//   return {
//     user: state.user,
//   };
// };

// const mapDispatchToProps = (dispatch) => {
//   return {
//     setUser: (user) => dispatch(setUser(user)),
//   };
// };

// class Mock extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: [],
//       activeTab: 0,
//       all_ok1: true,
//       all_ok: true,
//       count: [100, 100, 100, 100, 100],
//       currentSection: "Speaking Section",
//       subscriptionId:
//         store.getState().user.active_subscription &&
//         store.getState().user.active_subscription.length > 0
//           ? store.getState().user.active_subscription[0].stripe_subscription_id
//           : null,
//     };
//   }

//   componentDidMount() {
//     let isChrome =
//       /Chrome/.test(navigator.userAgent) &&
//       !/Edg/.test(navigator.userAgent) &&
//       /Google Inc/.test(navigator.vendor) &&
//       !/Chromium/.test(navigator.userAgent);
//     let all_ok1 = isChrome ? true : false;
//     if (navigator.getUserMedia === undefined) {
//       this.setState({ all_ok: false, all_ok1: false });
//     } else {
//       navigator.getUserMedia(
//         { audio: true },
//         (devices) => {
//           console.log("Permission Granted", devices);
//           this.setState({ all_ok1: all_ok1 });
//         },
//         (error) => {
//           this.setState({ all_ok1: false });
//           console.log("Permission Denied", error);
//         }
//       );
//     }

//     let new_format = 0;
//     if (this.props.location.pathname === "/admin/mocks/new-sectional-tests") {
//       new_format = 1;
//     }

//     this.getMocks(new_format);
//   }

//   componentDidUpdate(prevProps) {
//     if (this.props.location.pathname !== prevProps.location.pathname) {
//       if (this.props.location.pathname === "/admin/mocks/new-sectional-tests") {
//         this.getMocks(1);
//       } else if (this.props.location.pathname === "/admin/mock") {
//         this.getMocks(0);
//       }
//     }
//   }

//   getMocks = (new_format) => {
//     API({
//       method: "GET",
//       url: "web/mock1?new_format=" + new_format,
//     })
//       .then((data) => {
//         let tab = 1;
//         // this.props.location.pathname === '/admin/mocks/new-sectional-tests' && (tab = 2);
//         this.toggle(tab);
//         this.props.setUser(data.data.user);
//         let count = [100, 100, 100, 100, 100];
//         //if (this.state.subscriptionId) {
//         count = [
//           data.data.user.speak_ct,
//           data.data.user.write_ct,
//           data.data.user.read_ct,
//           data.data.user.listen_ct,
//           data.data.user.full_ct,
//         ];
//         //}
//         const { result } = data.data;
//         const mocks = result.reduce(
//           (acc, curr) => {
//             if (curr.type === 0) {
//               acc.type0.push(curr);
//             } else {
//               // if(curr.id) {
//               // 	acc.type1.unshift(curr);
//               // } else {
//               // 	acc.type1.push(curr);
//               // }
//               acc.type1.push(curr);
//             }
//             return acc;
//           },
//           { type0: [], type1: [] }
//         );
//         const { type0, type1 } = mocks;
//         this.setState({ data: [...type0, ...type1], count: count });
//       })
//       .catch(() => {});
//   };

//   toggle = (tab) => {
//     let all_ok = true;
//     if (this.state.activeTab !== tab) {
//       let currentSection = "";
//       switch (tab) {
//         case 1:
//           //currentSection = "Speaking Section";
//           break;
//         case 2:
//           //currentSection = "Writing Section";
//           break;
//         case 3:
//           //currentSection = "Reading Section";
//           break;
//         case 4:
//           //currentSection = "Listening Section";
//           break;
//         case 5:
//           // code block
//           break;
//         default:
//         // code block
//       }
//       this.setState(
//         {
//           activeTab: tab,
//           currentSection: currentSection,
//         },
//         () => {
//           if ([1, 5].includes(this.state.activeTab)) {
//             all_ok = this.state.all_ok1;
//           } else {
//             all_ok = true;
//           }
//           this.setState({ all_ok: all_ok });
//         }
//       );
//     }
//   };

//   redirectToMock = (id, event) => {
//     event.preventDefault();
//     const index = event.target.attributes["data-id"].value;
//     const { new_format } = this.state.data[index];
//     this.props.navigate(`/admin/${new_format ? "sectionalTest" : "test"}`, {
//       state: {
//         id,
//         pending: 0,
//       },
//     });
//   };

//   redirectToFullMock = (id, event) => {
//     event.preventDefault();
//     this.props.navigate(`/admin/fulltest`, {
//       state: {
//         id,
//         pending: 0,
//       },
//     });
//   };

//   render() {
//     let i = 0;
//     return (
//       <>
//         <Helmet>
//           <title>Top PTE Training Institute</title>
//         </Helmet>
//         {true && (
//           <div className="content tabs-content p-0 mock-test">
//             <DashboardHeader title="Mock Test" />
//             <Row className="outer-wrapper">
//               <Col xs={12}>
//                 <Card className="border-0 card-wrapper">
//                   <div className="dailytask-header">
//                     <Card.Header>
//                       <div className="dailytask-title">Mock Test</div>
//                       {false && this.state.activeTab !== 5 && (
//                         <Link
//                           to={`/admin/progress/${this.state.activeTab}?mock=1`}
//                         >
//                           <Button>
//                             Score Analysis of {this.state.currentSection}
//                           </Button>
//                         </Link>
//                       )}
//                     </Card.Header>
//                     <div className="d-flex align-items-center justify-content-center flex-wrap flex-md-nowrap">
//                       <div>
//                         {this.props.location.pathname !==
//                           "/admin/mocks/new-sectional-tests" && (
//                           <Nav
//                             className="nav-pills-primary nav-pills-icons justify-content-center"
//                             pills
//                             role="tablist"
//                             tabs
//                           >
//                             <NavItem>
//                               <NavLink1
//                                 className={
//                                   this.state.activeTab === 1 ? "active" : ""
//                                 }
//                                 id="mockspeaking"
//                                 onClick={() => {
//                                   this.toggle(1);
//                                 }}
//                               >
//                                 Speaking
//                               </NavLink1>
//                             </NavItem>
//                             <NavItem>
//                               <NavLink1
//                                 className={
//                                   this.state.activeTab === 2 ? "active" : ""
//                                 }
//                                 onClick={() => {
//                                   this.toggle(2);
//                                 }}
//                               >
//                                 Writing
//                               </NavLink1>
//                             </NavItem>
//                             <NavItem>
//                               <NavLink1
//                                 className={
//                                   this.state.activeTab === 3 ? "active" : ""
//                                 }
//                                 onClick={() => {
//                                   this.toggle(3);
//                                 }}
//                               >
//                                 Reading
//                               </NavLink1>
//                             </NavItem>
//                             <NavItem>
//                               <NavLink1
//                                 className={
//                                   this.state.activeTab === 4 ? "active" : ""
//                                 }
//                                 onClick={() => {
//                                   this.toggle(4);
//                                 }}
//                               >
//                                 Listening
//                               </NavLink1>
//                             </NavItem>
//                             <NavItem>
//                               <NavLink1
//                                 className={
//                                   this.state.activeTab === 5 ? "active" : ""
//                                 }
//                                 onClick={() => {
//                                   this.toggle(5);
//                                 }}
//                               >
//                                 Full Mock Test
//                               </NavLink1>
//                             </NavItem>
//                           </Nav>
//                         )}
//                         {this.props.location.pathname ===
//                           "/admin/mocks/new-sectional-tests" && (
//                           <TopNavPills
//                             activeTab={this.state.activeTab}
//                             toggle={this.toggle}
//                           />
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                   <Card.Body className="p-0">
//                     {!this.state.all_ok && (
//                       <div className="mt-5">
//                         <ChromeCheck />
//                       </div>
//                     )}
//                     {this.state.all_ok && (
//                       <>
//                         <div className="table-wrapper">
//                           <Table>
//                             <thead className="text-primary">
//                               <tr>
//                                 <th className="table-counting">#</th>
//                                 <th className="">Title</th>
//                                 <th className="">Description</th>
//                                 <th className="">Time</th>
//                                 <th className="table-action">Action</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {this.state.data.map((prop, key) => {
//                                 if (prop.category == this.state.activeTab) {
//                                   if (prop.type === 0 || prop.id) {
//                                     i++;
//                                     return (
//                                       <tr key={key}>
//                                         <td>{key + 1}</td>
//                                         <td className="">{prop.title}</td>
//                                         <td className="">{prop.description}</td>
//                                         <td className="">{prop.time}</td>
//                                         <td className="">
//                                           {prop.category !== 5 && (
//                                             <a
//                                               href="#"
//                                               id="take-mock"
//                                               data-id={key}
//                                               onClick={this.redirectToMock.bind(
//                                                 this,
//                                                 prop.id
//                                               )}
//                                               className="nav-link view-btn"
//                                             >
//                                               {/* data-id={key} */}
//                                               <img
//                                                 className="view-btn-icon"
//                                                 src={ArrowIcon}
//                                                 alt="Take Test"
//                                               />
//                                               Take Test
//                                             </a>
//                                           )}
//                                           {prop.category === 5 && (
//                                             <a
//                                               href="#"
//                                               onClick={this.redirectToFullMock.bind(
//                                                 this,
//                                                 prop.id
//                                               )}
//                                               className="nav-link view-btn"
//                                             >
//                                               <img
//                                                 className="view-btn-icon"
//                                                 src={ArrowIcon}
//                                                 alt="Take Full Test"
//                                               />
//                                               Take Full Test
//                                             </a>
//                                           )}
//                                         </td>
//                                       </tr>
//                                     );
//                                   } else {
//                                     return (
//                                       <tr key={key}>
//                                         <td>{key + 1}</td>
//                                         <td className="">{prop.title}</td>
//                                         <td className="">{prop.description}</td>
//                                         <td className="">{prop.time}</td>
//                                         <td className="">
//                                           <Link to="/admin/plans">
//                                             Subscribe to mock plan
//                                           </Link>
//                                         </td>
//                                       </tr>
//                                     );
//                                   }
//                                 }
//                               })}
//                             </tbody>
//                           </Table>
//                         </div>
//                         {/* {
// 													this.props.user.active_subscription.length < 1 &&
// 													<div style={{textAlign: "-webkit-center"}}>
// 														<div className="border m-4 p-3" style={{borderRadius: "50px", width: "30%"}}>
// 															<Link to={"/mock-plan"} style={{color: "#94C23C"}}>Purchase plan to see more mocks</Link>
// 														</div>
// 													</div>
// 												} */}
//                       </>
//                     )}
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </Row>
//             {this.props.location.pathname ===
//             "/admin/mocks/new-sectional-tests" ? (
//               <ExtensiveMockTour />
//             ) : (
//               <MockTour />
//             )}
//           </div>
//         )}
//       </>
//     );
//   }
// }

// // Wrapper component to handle React Router v6 location and navigation
// const MockWrapper = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   return <Mock location={location} navigate={navigate} />;
// };

// export default connect(mapStateToProps, mapDispatchToProps)(MockWrapper);

// import React, { useEffect, useState, useCallback } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import {
//   Card,
//   Card.Body,
//   Card.Header,
//   Table,
//   Row,
//   Col,
//   Button,
//   Nav,
//   NavItem,
//   NavLink as NavLink1,
// } from "reactstrap";
// import API from "api.js";
// import ChromeCheck from "views/ChromeCheckGlobal.jsx";
// import { setUser } from "action/index.js";
// import { useSelector, useDispatch } from "react-redux";
// import { store } from "store/index";
// import { Helmet } from "react-helmet";
// import TopNavPills from "components/SectionalTest/TopNavPills";
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
// import ArrowIcon from "../assets/images/images_new/sidebar-icons/06.svg";
// import ExtensiveMockTour from "components/WebsiteTour/ExtensiveMockTour";
// import MockTour from "components/WebsiteTour/MockTour";
// import Pagination from "components/Question/Mocks/Pagination";

// const Mock = () => {
//   const user = useSelector((state) => state.user);
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [data, setData] = useState([]);
//   const [activeTab, setActiveTab] = useState(0);
//   const [allOk1, setAllOk1] = useState(true);
//   const [allOk, setAllOk] = useState(true);
//   // const [count, setCount] = useState([100, 100, 100, 100, 100]);
//   const [count, setCount] = useState(10)
//   const [currentSection, setCurrentSection] = useState("Speaking Section");
//   const [page, setPage] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [displaying_items, setDisplaying_items] = useState(10);
//   const [isLoading, setIsLoading] = useState(false);


//   const subscriptionId =
//     store.getState().user.active_subscription &&
//       store.getState().user.active_subscription.length > 0
//       ? store.getState().user.active_subscription[0].stripe_subscription_id
//       : null;

//   // 🔹 Handle Chrome + mic permission check
//   useEffect(() => {
//     const isChrome =
//       /Chrome/.test(navigator.userAgent) &&
//       !/Edg/.test(navigator.userAgent) &&
//       /Google Inc/.test(navigator.vendor) &&
//       !/Chromium/.test(navigator.userAgent);

//     if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
//       setAllOk(false);
//       setAllOk1(false);
//     } else {
//       navigator.mediaDevices
//         .getUserMedia({ audio: true })
//         .then((stream) => {
//           console.log("Permission Granted", stream);
//           setAllOk1(isChrome);
//         })
//         .catch((err) => {
//           console.log("Permission Denied", err);
//           setAllOk1(false);
//         });
//     }

//     let newFormat = 0;
//     if (location.pathname === "/admin/mocks/new-sectional-tests") {
//       newFormat = 1;
//     }

//     getMocks(newFormat);
//   }, []); // run once on mount

//   // 🔹 Handle path changes
//   useEffect(() => {
//     if (location.pathname === "/admin/mocks/new-sectional-tests") {
//       getMocks(1);
//     } else if (location.pathname === "/admin/mock") {
//       getMocks(0);
//     }
//   }, [location.pathname]);

//   // 🔹 Fetch mocks
//   const getMocks = useCallback(
//     (newFormat) => {
//       console.log("newFormat==", newFormat);

//       API({
//         method: "GET",
//         url: "web/mock1?new_format=" + newFormat,
//       })
//         .then((res) => {
//           const userData = res.data.user;
//           dispatch(setUser(userData));

//           const newCount = [
//             userData.speak_ct,
//             userData.write_ct,
//             userData.read_ct,
//             userData.listen_ct,
//             userData.full_ct,
//           ];
//           // setCount(newCount);

//           const { result } = res.data;
//           const mocks = result.reduce(
//             (acc, curr) => {
//               if (curr.type === 0) {
//                 acc.type0.push(curr);
//               } else {
//                 acc.type1.push(curr);
//               }
//               return acc;
//             },
//             { type0: [], type1: [] }
//           );

//           setData([...mocks.type0, ...mocks.type1]);
//           toggle(1);
//         })
//         .catch(() => { });
//     },
//     [dispatch]
//   );

//   console.log("mock question list");


//   // 🔹 Tab switching
//   const toggle = (tab) => {
//     if (activeTab !== tab) {
//       let section = "";
//       switch (tab) {
//         case 1:
//           section = "Speaking Section";
//           break;
//         case 2:
//           section = "Writing Section";
//           break;
//         case 3:
//           section = "Reading Section";
//           break;
//         case 4:
//           section = "Listening Section";
//           break;
//         case 5:
//           section = "Full Mock Test";
//           break;
//         default:
//           section = "";
//       }

//       setActiveTab(tab);
//       setCurrentSection(section);

//       if ([1, 5].includes(tab)) {
//         setAllOk(allOk1);
//       } else {
//         setAllOk(true);
//       }
//     }
//   };

//   // 🔹 Navigation handlers
//   const redirectToMock = (id, event, index) => {
//     event.preventDefault();
//     const { new_format } = data[index];
//     navigate(`/admin/${new_format ? "sectionalTest" : "test"}`, {
//       state: { id, pending: 0 },
//     });
//   };

//   const redirectToFullMock = (id, event) => {
//     event.preventDefault();
//     navigate(`/admin/fulltest`, {
//       state: { id, pending: 0 },
//     });
//   };

//   /**
//    * Update display items per page. in table.
//    */
//   const updateListingItems = (items, page) => {
//     // setState(prev => ({
//     //   ...prev,
//     //   count: items,
//     //   page: page,
//     // }));
//     setPage(page)
//     setCount(items);
//     // run api again to get updated listing.
//     // getMocks(page);
//   };

//   /**
//    * Change Pagination.
//    */
//   const paginationChange = (page) => {
//     // setState(prev => ({
//     //   ...prev,
//     //   page,
//     // }));
//     setPage(page);
//     // getMocks(page);
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Top PTE Training Institute</title>
//       </Helmet>
//       <div className="content tabs-content p-0 mock-test">
//         <DashboardHeader title="Mock Test" />
//         <Row className="outer-wrapper">
//           <Col xs={12}>
//             <Card className="border-0 card-wrapper">
//               <div className="dailytask-header">
//                 <Card.Header>
//                   <div className="dailytask-title">Mock Test</div>
//                   {false && activeTab !== 5 && (
//                     <Link to={`/admin/progress/${activeTab}?mock=1`}>
//                       <Button>Score Analysis of {currentSection}</Button>
//                     </Link>
//                   )}
//                 </Card.Header>
//                 <div className="d-flex align-items-center justify-content-center flex-wrap flex-md-nowrap">
//                   <div>
//                     {location.pathname !==
//                       "/admin/mocks/new-sectional-tests" && (
//                         <Nav
//                           className="nav-pills-primary nav-pills-icons justify-content-center"
//                           pills
//                           role="tablist"
//                           tabs
//                         >
//                           {[
//                             "Speaking",
//                             "Writing",
//                             "Reading",
//                             "Listening",
//                             "Full Mock Test",
//                           ].map((label, idx) => (
//                             <NavItem key={idx}>
//                               <NavLink1
//                                 className={activeTab === idx + 1 ? "active" : ""}
//                                 onClick={() => toggle(idx + 1)}
//                               >
//                                 {label}
//                               </NavLink1>
//                             </NavItem>
//                           ))}
//                         </Nav>
//                       )}
//                     {location.pathname ===
//                       "/admin/mocks/new-sectional-tests" && (
//                         <TopNavPills activeTab={activeTab} toggle={toggle} />
//                       )}
//                   </div>
//                 </div>
//               </div>
//               <Card.Body className="p-0">
//                 {!allOk && (
//                   <div className="mt-5">
//                     <ChromeCheck />
//                   </div>
//                 )}
//                 {allOk && (
//                   <div className="table-wrapper">
//                     <Table>
//                       <thead className="text-primary">
//                         <tr>
//                           <th className="table-counting">#</th>
//                           <th>Title</th>
//                           <th>Description</th>
//                           <th>Time</th>
//                           <th className="table-action">Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {data.map((prop, key) => {
//                           if (prop.category === activeTab) {
//                             if (prop.type === 0 || prop.id) {
//                               return (
//                                 <tr key={key}>
//                                   <td>{key + 1}</td>
//                                   <td>{prop.title}</td>
//                                   <td>{prop.description}</td>
//                                   <td>{prop.time}</td>
//                                   <td>
//                                     {prop.category !== 5 ? (
//                                       <a
//                                         href="#"
//                                         data-id={key}
//                                         onClick={(e) =>
//                                           redirectToMock(prop.id, e, key)
//                                         }
//                                         className="nav-link view-btn"
//                                       >
//                                         <img
//                                           className="view-btn-icon"
//                                           src={ArrowIcon}
//                                           alt="Take Test"
//                                         />
//                                         Take Test
//                                       </a>
//                                     ) : (
//                                       <a
//                                         href="#"
//                                         onClick={(e) =>
//                                           redirectToFullMock(prop.id, e)
//                                         }
//                                         className="nav-link view-btn"
//                                       >
//                                         <img
//                                           className="view-btn-icon"
//                                           src={ArrowIcon}
//                                           alt="Take Full Test"
//                                         />
//                                         Take Full Test
//                                       </a>
//                                     )}
//                                   </td>
//                                 </tr>
//                               );
//                             } else {
//                               return (
//                                 <tr key={key}>
//                                   <td>{key + 1}</td>
//                                   <td>{prop.title}</td>
//                                   <td>{prop.description}</td>
//                                   <td>{prop.time}</td>
//                                   <td>
//                                     <Link to="/admin/plans">
//                                       Subscribe to mock plan
//                                     </Link>
//                                   </td>
//                                 </tr>
//                               );
//                             }
//                           }
//                           return null;
//                         })}
//                       </tbody>
//                     </Table>
//                     <Pagination
//                       total={total}
//                       listing={displaying_items}
//                       updateListingItems={updateListingItems}
//                       page={page}
//                       paginationChange={paginationChange}
//                     />
//                   </div>
//                 )}
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//         {location.pathname === "/admin/mocks/new-sectional-tests" ? (
//           <ExtensiveMockTour />
//         ) : (
//           <MockTour />
//         )}
//       </div>
//     </>
//   );
// };

// export default Mock;


import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Card, Table, Row, Col, Button, Nav, Dropdown } from "react-bootstrap";
import API from "api.js";
import ChromeCheck from "views/ChromeCheckGlobal.jsx";
import { setUser } from "action/index.js";
import { useSelector, useDispatch } from "react-redux";
import { store } from "store/index";
import { Helmet } from "react-helmet";
import TopNavPills from "components/SectionalTest/TopNavPills";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import ArrowIcon from "../assets/images/images_new/sidebar-icons/06.svg";
// import extensiveTour from "components/WebsiteTour/extensiveTour";
import MockTour from "components/WebsiteTour/MockTour";
import Spinner from "components/Loader/Spinner";
import MockPagination from "components/Question/Mocks/Pagination";
import ExtensiveMockTour from "components/WebsiteTour/ExtensiveMockTour";
import EmptyData from "components/EmptyData/EmptyData";

const Mock = () => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState(1); // Start with tab 1 (Speaking)
  const [allOk1, setAllOk1] = useState(true);
  const [allOk, setAllOk] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [displaying_items, setDisplaying_items] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [currentSection, setCurrentSection] = useState("Speaking Section");
  const [showModalMock, setShowModalMock] = useState(false);
   const [showModalExtensiveMock, setShowModalExtensiveMock] = useState(false);

  const subscriptionId =
    store.getState().user.active_subscription &&
      store.getState().user.active_subscription.length > 0
      ? store.getState().user.active_subscription[0].stripe_subscription_id
      : null;

  // 🔹 Handle Chrome + mic permission check
  useEffect(() => {
    console.log("Here is the Mock page")
    const isChrome =
      /Chrome/.test(navigator.userAgent) &&
      !/Edg/.test(navigator.userAgent) &&
      /Google Inc/.test(navigator.vendor) &&
      !/Chromium/.test(navigator.userAgent);

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setAllOk(false);
      setAllOk1(false);
    } else {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          console.log("Permission Granted", stream);
          setAllOk1(true);
        })
        .catch((err) => {
          console.log("Permission Denied", err);
          setAllOk1(false);
        });
    }

    let newFormat = location.pathname === "/admin/extensive/new-sectional-tests" ? 1 : 0;
    getMocks(newFormat);
  }, []);

  // 🔹 Handle path changes
  useEffect(() => {
    let newFormat = location.pathname === "/admin/extensive/new-sectional-tests" ? 1 : 0;
    getMocks(newFormat);
  }, [location.pathname]);

  // 🔹 Fetch mocks
  const getMocks = useCallback(
    (newFormat) => {
      setIsLoading(true);
      API({
        method: "GET",
        url: "web/mock1?new_format=" + newFormat,
      })
        .then((res) => {
          const userData = res.data.user;
          dispatch(setUser(userData));

          const { result } = res.data;
          const mocks = result.reduce(
            (acc, curr) => {
              if (curr.type === 0) {
                acc.type0.push(curr);
              } else {
                acc.type1.push(curr);
              }
              return acc;
            },
            { type0: [], type1: [] }
          );

          const allData = [...mocks.type0, ...mocks.type1];
          setData(allData);
          // Set total to the number of items for the active tab
          setTotal(allData.filter((item) => item.category === activeTab).length);
          toggle(activeTab || 1);
          setIsLoading(false);
          setShowModalMock(true);
          setShowModalExtensiveMock(true);
        })
        .catch((err) => {
          console.error("Error fetching mocks:", err);
          setIsLoading(false);
        });
    },
    [dispatch, activeTab]
  );

  // 🔹 Update total when activeTab changes
  useEffect(() => {
    setTotal(data.filter((item) => item.category === activeTab).length);
    setPage(1); // Reset to page 1 when tab changes
  }, [activeTab, data]);

  // 🔹 Tab switching
  const toggle = (tab) => {
    if (activeTab !== tab) {
      let section = "";
      switch (tab) {
        case 1:
          section = "Speaking Section";
          break;
        case 2:
          section = "Writing Section";
          break;
        case 3:
          section = "Reading Section";
          break;
        case 4:
          section = "Listening Section";
          break;
        case 5:
          section = "Full Mock Test";
          break;
        default:
          section = "";
      }

      setActiveTab(tab);
      setCurrentSection(section);

      // if ([1, 5].includes(tab)) {
      //   setAllOk(allOk1);
      // } else {
      //   setAllOk(true);
      // }
    }
  };

  // Navigation handlers
  const redirectToMock = (id, index, event) => {
    event.preventDefault();
    const { new_format } = data[index];
    navigate(`/admin/${new_format ? "sectionalTest" : "test"}`, {
      state: { id, pending: 0 },
    });
  };

  const redirectToFullMock = (id, event) => {
    event.preventDefault();
    navigate(`/admin/fulltest/${id}/0`, {
      state: { id, pending: 0 },
    });
  };

  // Update display items per page
  const updateListingItems = (items, page) => {
    setDisplaying_items(items);
    setPage(1);
  };

  // Change Pagination
  const paginationChange = (page) => {
    setPage(page);
  };

  // Filter data for the current page
  const getPaginatedData = () => {
    const filteredData = data.filter((item) => item.category === activeTab);
    const startIndex = (page - 1) * displaying_items;
    const endIndex = startIndex + displaying_items;
    return filteredData.slice(startIndex, endIndex);
  };

  return (
    <>
      <Helmet>
        <title>Top PTE Training Institute</title>
      </Helmet>
      <div className="content tabs-content p-0 mock-test">
        <DashboardHeader title={location.pathname === "/admin/extensive/new-sectional-tests" ? "Extensive Mock Test" : "Mock Test"} />
        <Row className="outer-wrapper" >
          <Col xs={12} className="sp-0">
            <Card className={`border-0 card-wrapper m-0 m-md-4 w-auto ${getPaginatedData()?.length > 0 ? "listing_height_test" : ""}`}>
              <div className="dailytask-header">
                <Card.Header>
                  <div className="dailytask-title">{location.pathname === "/admin/extensive/new-sectional-tests" ? 'Extensive' : ''} Mock Test</div>
                  {false && activeTab !== 5 && (
                    <Link to={`/admin/progress/${activeTab}?mock=1`}>
                      <Button>Score Analysis of {currentSection}</Button>
                    </Link>
                  )}
                </Card.Header>
                <div className="d-flex align-items-center justify-content-center flex-wrap flex-md-nowrap mt-2">
                  <div className="w-100 px-3">
                    <div className="d-md-none mb-3">
                      <Dropdown className="w-100 mobile-category-dropdown">
                        <Dropdown.Toggle variant="none" id="dropdown-basic" className="w-100 text-start d-flex justify-content-between align-items-center">
                          <span>
                            {[
                              "Speaking",
                              "Writing",
                              "Reading",
                              "Listening",
                              "Full Mock Test",
                            ][activeTab - 1]}
                          </span>
                          <i className="fa fa-chevron-down small opacity-50"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {(location.pathname === "/admin/extensive/new-sectional-tests"
                            ? ["Speaking", "Writing", "Reading", "Listening"]
                            : ["Speaking", "Writing", "Reading", "Listening", "Full Mock Test"]
                          ).map((label, idx) => (
                            <Dropdown.Item
                              key={idx}
                              active={activeTab === idx + 1}
                              onClick={() => toggle(idx + 1)}
                            >
                              {label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>

                    <div className="d-none d-md-block">
                      {location.pathname !== "/admin/extensive/new-sectional-tests" && (
                        <Nav
                          className="nav-pills-primary nav-pills-icons justify-content-center"
                          pills
                          role="tablist"
                          variant="tabs"
                        // tabs
                        >
                          {[
                            "Speaking",
                            "Writing",
                            "Reading",
                            "Listening",
                            "Full Mock Test",
                          ].map((label, idx) => (
                            <Nav.Item id="Mock-section" key={idx}>
                              <Nav.Link
                                className={activeTab === idx + 1 ? "active" : ""}
                                onClick={() => toggle(idx + 1)}
                              >
                                {label}
                              </Nav.Link>
                            </Nav.Item>
                          ))}
                        </Nav>
                      )}
                      {location.pathname === "/admin/extensive/new-sectional-tests" && (
                        <TopNavPills activeTab={activeTab} toggle={toggle} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Card.Body className={`p-0 ${getPaginatedData()?.length > 0 ? "listing_height" : ""}`} >
                {isLoading &&
                  <Spinner />
                }
                {!allOk && (
                  <div className="mt-5">
                    <ChromeCheck />
                  </div>
                )}
                {allOk && !isLoading && (
                  <div className="table-wrapper">
                    {getPaginatedData()?.length === 0 ? (
                      <div className="p-3 text-center">
                        <EmptyData text={"No Mock Tests Found"} />
                      </div>
                    ) : (
                      <>
                        <div className="d-none d-md-block">
                      <Table>
                        <thead className="text-primary">
                          <tr>
                            <th className="table-counting">#</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Time</th>
                            <th className="table-action">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getPaginatedData().map((prop, key) => {
                            const globalIndex = data.findIndex(
                              (item) => item.id === prop.id
                            );
                            return (
                              <tr key={key}>
                                <td>{(page - 1) * displaying_items + key + 1}</td>
                                <td>{prop.title}</td>
                                <td>{prop.description}</td>
                                <td>{prop.time}</td>
                                <td id="Mock-view">
                                  {prop.category !== 5 ? (
                                    // Sectional Test Logic
                                    prop.type === 0 || prop.id ? (
                                      <a
                                        // Mock is available - show "Take Test"

                                        href="#"
                                        data-id={globalIndex}
                                        onClick={(e) => redirectToMock(prop.id, data.indexOf(prop), e)}
                                        className="nav-link view-btn"
                                      >
                                        <img
                                          className="view-btn-icon"
                                          src={ArrowIcon}
                                          alt="Take Test"
                                        />
                                        Take Test
                                      </a>
                                    ) : (
                                      // Mock is locked - show "Subscribe"
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          navigate("/admin/plans");
                                        }}
                                        className="nav-link view-btn"
                                      >
                                        <img
                                          className="view-btn-icon"
                                          src={ArrowIcon}
                                          alt="Subscribe"
                                        />
                                        Subscribe to mock plan
                                      </a>
                                    )
                                  ) : (
                                    // Full Mock Test Logic
                                    prop.type === 0 || prop.id ? (
                                      // Mock is available - show "Take Full Test"
                                      <a
                                        href="#"
                                        onClick={(e) => redirectToFullMock(prop.id, e)}
                                        className="nav-link view-btn"
                                      >
                                        <img
                                          className="view-btn-icon"
                                          src={ArrowIcon}
                                          alt="Take Full Test"
                                        />
                                        Take Full Test
                                      </a>
                                    ) : (
                                      // Mock is locked - show "Subscribe"
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          navigate("/admin/plans");
                                        }}
                                        className="nav-link view-btn"
                                      >
                                        <img
                                          className="view-btn-icon"
                                          src={ArrowIcon}
                                          alt="Subscribe"
                                        />
                                        Subscribe to mock plan
                                      </a>
                                    )
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>

                    <div className="mobile-table d-md-none mt-3">
                      {getPaginatedData().map((prop, key) => {
                        const globalIndex = data.findIndex(
                          (item) => item.id === prop.id
                        );
                        return (
                          <Card className="border-0 card-wrapper m-0 mb-3 p-3 shadow-sm rounded-4" key={key}>
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <h6 className="fw-bold mb-0 pe-2" style={{ fontSize: '1.1rem' }}>{prop.title}</h6>
                              <span className="badge rounded-pill px-3 py-2" style={{ backgroundColor: '#A3D951', color: '#fff', fontSize: '0.8rem' }}>
                                Time: {prop.time}min
                              </span>
                            </div>
                            <p className="text-muted small mb-3">{prop.description}</p>
                            
                            <div className="w-100">
                              {prop.category !== 5 ? (
                                prop.type === 0 || prop.id ? (
                                  <a
                                    href="#"
                                    onClick={(e) => redirectToMock(prop.id, data.indexOf(prop), e)}
                                    className="nav-link p-0 w-100"
                                  >
                                    <div className="view-btn w-100 d-flex justify-content-center align-items-center" style={{ maxWidth: 'none' }}>
                                      <img
                                        className="view-btn-icon"
                                        src={ArrowIcon}
                                        alt="Take Test"
                                        style={{ margin: '0 8px 0 0' }}
                                      />
                                      Take Test
                                    </div>
                                  </a>
                                ) : (
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      navigate("/admin/plans");
                                    }}
                                    className="nav-link p-0 w-100"
                                  >
                                    <div className="view-btn w-100 d-flex justify-content-center align-items-center" style={{ maxWidth: 'none' }}>
                                      Subscribe to mock plan
                                    </div>
                                  </a>
                                )
                              ) : (
                                prop.type === 0 || prop.id ? (
                                  <a
                                    href="#"
                                    onClick={(e) => redirectToFullMock(prop.id, e)}
                                    className="nav-link p-0 w-100"
                                  >
                                    <div className="view-btn w-100 d-flex justify-content-center align-items-center" style={{ maxWidth: 'none' }}>
                                      <img
                                        className="view-btn-icon"
                                        src={ArrowIcon}
                                        alt="Take Full Test"
                                        style={{ margin: '0 8px 0 0' }}
                                      />
                                      Take Full Test
                                    </div>
                                  </a>
                                ) : (
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      navigate("/admin/plans");
                                    }}
                                    className="nav-link p-0 w-100"
                                  >
                                    <div className="view-btn w-100 d-flex justify-content-center align-items-center" style={{ maxWidth: 'none' }}>
                                      Subscribe to mock plan
                                    </div>
                                  </a>
                                )
                              )}
                            </div>
                          </Card>
                        );
                      })}
                    </div>
                  </>
                )}

                    <MockPagination
                      total={total}
                      listing={displaying_items}
                      updateListingItems={updateListingItems}
                      page={page}
                      paginationChange={paginationChange}
                    />
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* {location.pathname === "/admin/mocks/new-sectional-tests" ? (
           showModalExtensiveMock && <ExtensiveMockTour autoStart={true} dataLoaded={showModalExtensiveMock}/>
        ) : (
          showModalMock && <MockTour autoStart={true} dataLoaded={showModalMock}/>
        )} */}
        {location.pathname === "/admin/extensive/new-sectional-tests" ? (
           showModalExtensiveMock && <ExtensiveMockTour autoStart={true} dataLoaded={showModalExtensiveMock}/>
        ) : (
          showModalMock && <MockTour autoStart={true} dataLoaded={showModalMock}/>
        )}
      </div>
    </>
  );
};

export default Mock;